import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer, Bounce } from 'react-toastify'

import { isMobile } from './components/utils'
import Routes from './routes/Routes'

const App: React.FC = () => {
  const mobile = isMobile()

  return (
    <Router>
      <Routes />
      <ToastContainer
        position={mobile ? 'top-center' : 'bottom-right'}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </Router>
  )
}

export default App
